import React from 'react';
import { useNavigate } from 'react-router-dom';
import { newsData } from '../data/newsData';

const NewsPage = () => {
  const navigate = useNavigate();

  const styles = {
    subPage: {
      minHeight: 'calc(100vh - 70px)',
      paddingBottom: '60px',
    },
    subPageHeader: {
      backgroundColor: '#2563eb',
      color: '#ffffff',
      padding: '80px 20px',
      textAlign: 'center',
    },
    subPageTitle: {
      fontSize: '48px',
      fontWeight: 'bold',
      marginBottom: '10px',
    },
    subPageSubtitle: {
      fontSize: '18px',
      color: '#dbeafe',
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    newsListPage: {
      padding: '60px 20px',
    },
    newsItemPage: {
      display: 'flex',
      alignItems: 'center',
      padding: '30px',
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      marginBottom: '20px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      gap: '20px',
      cursor: 'pointer',
      transition: 'transform 0.2s, box-shadow 0.2s',
    },
    newsDateLarge: {
      color: '#6b7280',
      fontSize: '16px',
      minWidth: '120px',
      fontWeight: 'bold',
    },
    newsCategoryLarge: {
      backgroundColor: '#dbeafe',
      color: '#2563eb',
      padding: '6px 16px',
      borderRadius: '4px',
      fontSize: '14px',
      fontWeight: 'bold',
      minWidth: '120px',
    },
    newsTitleLarge: {
      color: '#1f2937',
      fontSize: '18px',
      flex: 1,
      textAlign: 'left',
      marginLeft: '20px',
    },
  };

  return (
    <div style={styles.subPage}>
      <style>
        {`
          @media (max-width: 768px) {
            .sub-page-header-mobile {
              padding: 60px 20px !important;
            }
            .sub-page-title-mobile {
              font-size: 36px !important;
            }
            .sub-page-subtitle-mobile {
              font-size: 16px !important;
            }
            .news-list-page-mobile {
              padding: 40px 15px !important;
            }
            .news-item-page-mobile {
              flex-direction: column !important;
              align-items: flex-start !important;
              padding: 20px !important;
              gap: 10px !important;
            }
            .news-date-large-mobile {
              min-width: auto !important;
              font-size: 14px !important;
            }
            .news-category-large-mobile {
              min-width: auto !important;
              font-size: 12px !important;
              padding: 4px 12px !important;
            }
            .news-title-large-mobile {
              font-size: 15px !important;
              margin-left: 0 !important;
            }
          }
        `}
      </style>
      <div style={styles.subPageHeader} className="sub-page-header-mobile">
        <h1 style={styles.subPageTitle} className="sub-page-title-mobile">NEWS</h1>
        <p style={styles.subPageSubtitle} className="sub-page-subtitle-mobile">新着情報</p>
      </div>
      <div style={styles.container}>
        <div style={styles.newsListPage} className="news-list-page-mobile">
          {newsData.slice().reverse().map((news) => (
            <div 
              key={news.id} 
              style={styles.newsItemPage}
              className="news-item-page-mobile"
              onClick={() => navigate(`/news/${news.id}`)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
              }}
            >
              <div style={styles.newsDateLarge} className="news-date-large-mobile">{news.date}</div>
              <div style={styles.newsCategoryLarge} className="news-category-large-mobile">{news.category}</div>
              <div style={styles.newsTitleLarge} className="news-title-large-mobile">{news.title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsPage;